import { render, staticRenderFns } from "./ObjectsCard.vue?vue&type=template&id=c8d12f6e"
import script from "./ObjectsCard.vue?vue&type=script&lang=js"
export * from "./ObjectsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports